export class NPC {
    public name: string;
    public assetKey: string;
    public job: string;
    public responses: NPCResponse[];
    // NPC's corresponding Image
    public object: Phaser.GameObjects.Image;
    public enabled: boolean;
    public talkedTo: boolean;
    public id: number;
    public feedback: string;
    public picked: boolean;
    public backgroundAssetKey: string;
    public label?: Phaser.GameObjects.Text;

    constructor(id: number, name: string, assetKey: string, backgroundAssetKey: string, job: string, feedback: string, dialog: NPCResponse[]) {
        this.id = id;
        this.name = name;
        this.assetKey = assetKey;
        this.backgroundAssetKey = backgroundAssetKey;
        this.job = job;
        this.feedback = feedback;
        this.responses = dialog;
        this.object = null;
        this.enabled = true;
        this.talkedTo = false;
        this.picked = false;
    }

    /**
     * Translation keys stored instead of english
     */
    public static NPC_1 = new NPC(
        1,
        "FitFive.Phaser.NPCS.1.name",
        "astro-flares",
        "gym-zoomed-5",
        "FitFive.Phaser.NPCS.1.job",
        "FitFive.Phaser.NPCS.1.feedback",
        [
            { questionId: 0, textID: "FitFive.Phaser.NPCS.1.dialog.1" },
            { questionId: 1, textID: "FitFive.Phaser.NPCS.1.dialog.2" },
            { questionId: 2, textID: "FitFive.Phaser.NPCS.1.dialog.3" },
            { questionId: 3, textID: "FitFive.Phaser.NPCS.1.dialog.4" },
        ],
    );

    public static NPC_2 = new NPC(
        2,
        "FitFive.Phaser.NPCS.2.name",
        "pluto-tera",
        "gym-zoomed-4",
        "FitFive.Phaser.NPCS.2.job",
        "FitFive.Phaser.NPCS.2.feedback",
        [
            { questionId: 0, textID: "FitFive.Phaser.NPCS.2.dialog.1" },
            { questionId: 1, textID: "FitFive.Phaser.NPCS.2.dialog.2" },
            { questionId: 2, textID: "FitFive.Phaser.NPCS.2.dialog.3" },
            { questionId: 3, textID: "FitFive.Phaser.NPCS.2.dialog.4" },
        ],
    );

    public static NPC_3 = new NPC(
        3,
        "FitFive.Phaser.NPCS.3.name",
        "beta-borealis",
        "gym-zoomed-1",
        "FitFive.Phaser.NPCS.3.job",
        "FitFive.Phaser.NPCS.3.feedback",
        [
            { questionId: 0, textID: "FitFive.Phaser.NPCS.3.dialog.1" },
            { questionId: 1, textID: "FitFive.Phaser.NPCS.3.dialog.2" },
            { questionId: 2, textID: "FitFive.Phaser.NPCS.3.dialog.3" },
            { questionId: 3, textID: "FitFive.Phaser.NPCS.3.dialog.4" },
        ],
    );

    public static NPC_4 = new NPC(
        4,
        "FitFive.Phaser.NPCS.4.name",
        "neptuna-neutron",
        "gym-zoomed-2",
        "FitFive.Phaser.NPCS.4.job",
        "FitFive.Phaser.NPCS.4.feedback",
        [
            { questionId: 0, textID: "FitFive.Phaser.NPCS.4.dialog.1" },
            { questionId: 1, textID: "FitFive.Phaser.NPCS.4.dialog.2" },
            { questionId: 2, textID: "FitFive.Phaser.NPCS.4.dialog.3" },
            { questionId: 3, textID: "FitFive.Phaser.NPCS.4.dialog.4" },
        ],
    );

    public static NPC_5 = new NPC(
        5,
        "FitFive.Phaser.NPCS.5.name",
        "sunny-system",
        "gym-zoomed-3",
        "FitFive.Phaser.NPCS.5.job",
        "FitFive.Phaser.NPCS.5.feedback",
        [
            { questionId: 0, textID: "FitFive.Phaser.NPCS.5.dialog.1" },
            { questionId: 1, textID: "FitFive.Phaser.NPCS.5.dialog.2" },
            { questionId: 2, textID: "FitFive.Phaser.NPCS.5.dialog.3" },
            { questionId: 3, textID: "FitFive.Phaser.NPCS.5.dialog.4" },
        ],
    );

    public static ALL_NPCS: NPC[] = [
        NPC.NPC_1,
        NPC.NPC_2,
        NPC.NPC_3,
        NPC.NPC_4,
        NPC.NPC_5,
    ];
}

/**
 * Stores the question ID, the translation key, and whether it's been asked or not
 */
export class Question {
    public id: number;
    public textID: string;
    public asked: boolean;

    public static HELLO: Question = { id: 0, textID: "FitFive.Phaser.NPCS.%.dialog.1", asked: false }; // "Thank you for answering my three questions. Your answers will help me decide who will help Cosmos the most. I must return to the picture wall now."

    public static QUESTIONS: Question[] = [
        { id: 1, textID: "FitFive.Phaser.TalkToNPCScene.StudentQuestions.1", asked: false }, // What do you do when you are at work?
        { id: 2, textID: "FitFive.Phaser.TalkToNPCScene.StudentQuestions.2", asked: false }, //  How do you help people?
        { id: 3, textID: "FitFive.Phaser.TalkToNPCScene.StudentQuestions.3", asked: false }, // What is your favorite part of your job?
        { id: 4, textID: "FitFive.Phaser.TalkToNPCScene.studentGoodbye", asked: false } // "Thank you for answering my three questions. Your answers will help me decide who will help Cosmos the most. I must return to the picture wall now."
    ];
}

/**
 * Stores the corresponding question ID and the translation key
 */
export class NPCResponse {
    public questionId: number;
    public textID: string;
}






// WEBPACK FOOTER //
// ./src/games/FitFiveGame/objects/NPC.ts